import React, { useState } from "react";
import { toast } from "sonner";
import { Share2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../../components/ui/dialog";
import { ujmsV2ShareMacro } from "../../../services/ujmsApi";
import { btnGhost, btnPrimary } from "../../ui";

/** Judge publishes a personal macro to the clerks in their sessions — every courtroom, or just the one on the bench today. */
export function ShareMacroDialog({ macro, session, onClose, onDone }) {
  const [mode, setMode] = useState(macro.shared && macro.shareCourtroomId ? "ROOM" : "ALL");
  const [busy, setBusy] = useState(false);
  const apply = async (shared) => {
    setBusy(true);
    try {
      const r = await ujmsV2ShareMacro(macro.id, { shared, courtroom_id: shared && mode === "ROOM" ? session.courtroomId : null });
      toast.success(shared ? `"${macro.name}" shared with ${r.data.shareCourtroomName || "all your courtrooms"} — clerks now see it under Macros` : `"${macro.name}" is private to the bench again`);
      onDone();
    } catch (e) { toast.error(e.response?.data?.detail || "Share failed"); }
    setBusy(false);
  };
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md rounded-none" data-testid="share-macro-dialog">
        <DialogHeader><DialogTitle className="text-[14px] inline-flex items-center gap-1"><Share2 className="w-4 h-4" /> Share bench macro — {macro.name}</DialogTitle></DialogHeader>
        <div className="space-y-2 text-[12px]">
          <p className="text-slate-700">Shared macros appear in Clerk operations for clerks working your sessions. Only you can edit or unshare them.</p>
          <div className="border border-slate-300 divide-y divide-slate-200">
            <label className="flex items-center gap-2 px-2 py-1 cursor-pointer"><input type="radio" checked={mode === "ALL"} onChange={() => setMode("ALL")} data-testid="share-mode-all" /><span><b>All my courtrooms</b> — every session where I preside</span></label>
            <label className="flex items-center gap-2 px-2 py-1 cursor-pointer"><input type="radio" checked={mode === "ROOM"} onChange={() => setMode("ROOM")} disabled={!session?.courtroomId} data-testid="share-mode-room" /><span><b>This courtroom only</b> — {session?.courtroom || "no courtroom on this session"}</span></label>
          </div>
          {macro.shared && <div className="text-[11px] text-slate-500">Currently shared {macro.shareCourtroomName ? `in ${macro.shareCourtroomName}` : "in all courtrooms"} since {String(macro.sharedAt || "").slice(0, 16).replace("T", " ")}.</div>}
        </div>
        <DialogFooter>
          <button className={btnGhost} onClick={onClose}>Cancel</button>
          {macro.shared && <button className={btnGhost} disabled={busy} onClick={() => apply(false)} data-testid="share-macro-unshare">Unshare</button>}
          <button className={btnPrimary} disabled={busy} onClick={() => apply(true)} data-testid="share-macro-confirm">{macro.shared ? "Update sharing" : "Share with courtroom"}</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
